import forge from "node-forge";
import environment from "../../environment";

export function encrypt(obj) {
  if(obj){
    const secretKey = environment.secret_key
    const iv = environment.iv_key
    const cipher = forge.cipher.createCipher('AES-CBC', secretKey);
    cipher.start({ iv });
    const jsonString = JSON.stringify(obj);
    cipher.update(forge.util.createBuffer(jsonString, 'utf8'));
    cipher.finish();
    return cipher.output.toHex();
  }else{
    return ""
  }
};

export function decrypt(encryptedHex) {
  if(encryptedHex){
    const secretKey = environment.secret_key
    const iv = environment.iv_key;
    const decipher = forge.cipher.createDecipher('AES-CBC', secretKey);
    decipher.start({ iv });
    decipher.update(forge.util.createBuffer(forge.util.hexToBytes(encryptedHex)));
    const success = decipher.finish();
    if (!success) {
      return ""
    }
    const decryptedStr = decipher.output.toString('utf8');
    return JSON.parse(decryptedStr);
  }else{
    return ""
  }
};